import styles from "./TabStyles.module.css";

export const TabStyles = {
  element: styles["tabs"],
  tabTitleHolder: styles["tab-title-holder"],
  tabContents: styles["tab-contents"],
  tab: styles["tab"],
  activeTab: styles["active-tab"],
};
